import React from 'react';

import styles from './styles.module.scss';

function LayoutPrint({ children }) {
  return <div className={styles.layout}>{children}</div>;
}

export { LayoutPrint };
